export default __webpack_public_path__ + "static/O0066-9447937b44d99dbaa7e6f1d0391b6819.png";